/**
 * key: route path
 * title: menu name / browser title
 * icon: menu icon
 * component: corresponding component
 * code: permission code (used for matching permission API)
 */
export default {
    menus: [ // Menu-related routes
        {
            key: '/updatelog', title: 'UpdateLog', icon: 'icon-settings', component: 'UpdateLog', code: 'updatelog'
        },
        {
            key: '/tenantsdata', title: 'TenantsData', icon: 'icon-reports', component: 'TenantsData', code: 'tenantsdata'
        },
        {
            key: '/failed', title: 'Failed To Delete Users', icon: 'icon-user-id-new', component: 'DeleteUsersList', code: 'failed'
        },
        {
            key: '/contact', title: 'Update Contact', icon: 'icon-edit', component: 'UpdateContactInfo', code: 'contact'
        },
        {
            key: '/updateregion', title: 'UpdateRegion', icon: 'icon-settings', component: 'UpdateRegion', code: 'updateregion'
        },
        {
            key: '/updatecountry', title: 'UpdateCountry', icon: 'icon-settings', component: 'UpdateCountry', code: 'updatecountry'
        },
        {
            key: '/existLicenses', title: 'Taking over existing licenses', icon: 'icon-logs', component: 'ExistingLicense' , code: 'existLicenses'
        },
        {
            key: '/permission', title: 'Permission Management', icon: 'icon-license-new', code: 'permission',
            subs: [
                { key: '/permission/admin', title: 'AdminManagement', component: 'AdminManage', code: 'permission_admin' },
                { key: '/permission/role', title: 'RoleManagement', component: 'RoleManage', code: 'permission_role' },
            ],
        },
        { key: '/contentlogs', title: 'ContentLogs', icon: 'icon-logs', component: 'AdminOperationLogs', code: 'contentlogs' },
    ],
    others: [] // Non-menu routes
}
